module.exports = __webpack_public_path__ + "static/media/icon-account.0bf24edf.svg";